import React, { useState } from 'react';
import { Check, X, Copy, Receipt, Wallet } from 'lucide-react';
import './AstrologyWalletPayment.css';
import Footer from "../footer/footer";
import Header from "../header/header";

const AstrologyWalletPayment = () => {
  const [activeTab, setActiveTab] = useState('recharge');
  const [selectedAmount, setSelectedAmount] = useState(100);
  const [customAmount, setCustomAmount] = useState('100');
  const [promoCode, setPromoCode] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [walletBalance] = useState(2500);

  const predefinedAmounts = [100, 200, 500, 1000, 2000, 5000];
  
  const transactionHistory = [
    { id: 1, name: 'Priya Sharma', time: 'Today, 10:30am', amount: 500, status: 'Successful', type: 'debit' },
    { id: 2, name: 'Rahul Verma', time: 'Today, 09:15am', amount: 300, status: 'Pending', type: 'debit' },
    { id: 3, name: 'Wallet Recharge', time: 'Yesterday, 05:20pm', amount: 1000, status: 'Successful', type: 'credit' },
    { id: 4, name: 'Meena Patel', time: 'Yesterday, 03:45pm', amount: 700, status: 'Refunded', type: 'credit' },
  ];

  const handleAmountSelect = (amount) => {
    setSelectedAmount(amount);
    setCustomAmount(amount.toString());
  };

  const handleCustomAmountChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setCustomAmount(value);
    setSelectedAmount(parseInt(value) || 0);
  };

  const calculateTotal = () => {
    const amount = selectedAmount || 0;
    const discount = promoCode ? 50 : 0;
    return amount - discount;
  };

  const handlePayment = () => {
    const isSuccess = Math.random() > 0.3;
    if (isSuccess) {
      setShowSuccess(true);
    } else {
      setShowFailure(true);
    }
  };

  if (showSuccess) {
    return (
      <div className="payment-status-container">
        <div className="payment-status-card">
          <div className="status-icon success-icon">
            <Check className="icon-svg" strokeWidth={3} />
          </div>
          <h1 className="status-title">Payment Successful!</h1>
          <p className="status-subtitle">Wallet Recharged</p>
          <div className="status-amount">₹{selectedAmount}</div>
          <div className="status-date">12 September 2025, 09:00 PM</div>
          <div className="status-transaction">
            <span>Transaction ID: 673823827363</span>
            <Copy className="copy-icon" />
          </div>
          <div className="status-buttons">
            <button className="btn-light" onClick={() => setShowSuccess(false)}>Back to Wallet</button>
            <button className="btn-dark" onClick={() => setShowSuccess(false)}>Done</button>
          </div>
        </div>
      </div>
    );
  }

  if (showFailure) {
    return (
      <div className="payment-status-container">
        <div className="payment-status-card">
          <div className="status-icon failure-icon">
            <X className="icon-svg" strokeWidth={3} />
          </div>
          <h1 className="status-title">Payment Failed</h1>
          <p className="status-subtitle">Transaction could not be completed</p>
          <div className="status-amount">₹{selectedAmount}</div>
          <p className="failure-message">Payment gateway error. Please try again.</p>
          <div className="status-date">12 September 2025, 09:00 PM</div>
          <div className="status-transaction">
            <span>Transaction ID: 673823827363</span>
            <Copy className="copy-icon" />
          </div>
          <div className="status-buttons">
            <button className="btn-light" onClick={() => setShowFailure(false)}>Try Again</button>
            <button className="btn-dark" onClick={() => setShowFailure(false)}>Cancel</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="wallet-container">
        <div className="wallet-main">
          <div className="wallet-card">
            {activeTab === 'recharge' && (
              <div className="balance-display-new">
                <div className="balance-content">
                  <div className="balance-info-left">
                    <p className="balance-label-new">Available Balance</p>
                    <h2 className="balance-amount-new">₹{walletBalance.toLocaleString()}</h2>
                  </div>
                  <div className="balance-icon-wrapper">
                    <Wallet className="balance-icon" size={40} />
                  </div>
                </div>
              </div>
            )}

            <div className="wallet-tabs">
              <button
                onClick={() => setActiveTab('recharge')}
                className={`tab-button ${activeTab === 'recharge' ? 'tab-active' : ''}`}
              >
                Recharge Wallet
              </button>
              <button
                onClick={() => setActiveTab('history')}
                className={`tab-button ${activeTab === 'history' ? 'tab-active' : ''}`}
              >
                Transaction History
              </button>
            </div>

            <div className="wallet-content">
              {activeTab === 'recharge' ? (
                <div>
                  <div className="amount-section">
                    <label className="form-label">Select Amount</label>
                    <div className="amount-grid">
                      {predefinedAmounts.map((amount) => (
                        <button
                          key={amount}
                          onClick={() => handleAmountSelect(amount)}
                          className={`amount-btn ${selectedAmount === amount ? 'amount-btn-active' : ''}`}
                        >
                          ₹{amount}
                        </button>
                      ))}
                    </div>
                    <div className="custom-amount">
                      <span className="rupee-symbol">₹</span>
                      <input
                        type="text"
                        value={customAmount}
                        onChange={handleCustomAmountChange}
                        placeholder="Enter custom amount"
                        className="amount-input"
                      />
                    </div>
                  </div>

                  <div className="payment-method-section">
                    <label className="form-label">Payment Method</label>
                    <div className="payment-methods">
                      <div className="payment-option">
                        <div className="payment-info">
                          <div className="payment-icon card-icon">
                            <div className="card-stripe"></div>
                          </div>
                          <div>
                            <div className="payment-name">Credit/Debit Card</div>
                            <div className="payment-desc">Visa, Mastercard, RuPay</div>
                          </div>
                        </div>
                        <span className="arrow-icon">›</span>
                      </div>

                      <div className="payment-option">
                        <div className="payment-info">
                          <div className="payment-icon upi-icon">₹</div>
                          <div>
                            <div className="payment-name">UPI Payment</div>
                            <div className="payment-desc">Google Pay, PhonePe, Paytm</div>
                          </div>
                        </div>
                        <span className="arrow-icon">›</span>
                      </div>

                      <div className="payment-option">
                        <div className="payment-info">
                          <div className="payment-icon bank-icon">🏦</div>
                          <div>
                            <div className="payment-name">Net Banking</div>
                            <div className="payment-desc">All major banks</div>
                          </div>
                        </div>
                        <span className="arrow-icon">›</span>
                      </div>
                    </div>
                  </div>

                  <div className="promo-section">
                    <label className="form-label">Have a Promo Code?</label>
                    <div className="promo-input-group">
                      <input
                        type="text"
                        value={promoCode}
                        onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                        placeholder="Enter code"
                        className="promo-input"
                      />
                      <button className="apply-btn">Apply</button>
                    </div>
                  </div>

                  <div className="price-breakdown">
                    <div className="price-row">
                      <span>Recharge Amount</span>
                      <span className="price-value">₹{selectedAmount.toFixed(2)}</span>
                    </div>
                    <div className="price-row">
                      <span>Convenience Fee</span>
                      <span className="price-value">₹0.00</span>
                    </div>
                    {promoCode && (
                      <div className="price-row">
                        <span>Promo Discount</span>
                        <span className="price-value discount">-₹50.00</span>
                      </div>
                    )}
                    <div className="price-row total-row">
                      <span className="total-label">Total Payable</span>
                      <span className="total-value">₹{calculateTotal().toFixed(2)}</span>
                    </div>
                  </div>

                  <button onClick={handlePayment} className="proceed-btn">
                    Proceed to Payment
                  </button>
                </div>
              ) : (
                <div>
                  <div className="filter-section">
                    <select className="filter-select">
                      <option>All Status</option>
                      <option>Successful</option>
                      <option>Pending</option>
                      <option>Failed</option>
                      <option>Refunded</option>
                    </select>
                    <select className="filter-select">
                      <option>All Time</option>
                      <option>Today</option>
                      <option>This Week</option>
                      <option>This Month</option>
                    </select>
                  </div>

                  <div className="transaction-list">
                    {transactionHistory.map((transaction) => (
                      <div key={transaction.id} className="transaction-item">
                        <div className="transaction-header">
                          <div className="transaction-user">
                            <div className="user-avatar">{transaction.name.charAt(0)}</div>
                            <div>
                              <div className="user-name">{transaction.name}</div>
                              <div className="transaction-time">{transaction.time}</div>
                            </div>
                          </div>
                          <span className={`transaction-status status-${transaction.status.toLowerCase()}`}>
                            {transaction.status}
                          </span>
                        </div>
                        <div className="transaction-footer">
                          <div className={`transaction-amount ${transaction.type === 'credit' ? 'amount-credit' : 'amount-debit'}`}>
                            {transaction.type === 'credit' ? '+' : '-'}₹{transaction.amount}
                          </div>
                          <button className="receipt-btn">
                            <Receipt className="receipt-icon" />
                            Receipt
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  <button className="load-more-btn">Load More Transactions</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AstrologyWalletPayment;